import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

export class UserRecommendForm extends FormBase {
    public getOverlay(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_RECOMMEND_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getModal(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_RECOMMEND_MODAL}"]`, HTMLElement);
    }

    public getListRoot(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_RECOMMEND_MODAL_LIST}"]`, HTMLElement);
    }

    public getCloseButton(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_RECOMMEND_MODAL_CLOSE}"]`, HTMLElement);
    }

    public getClearButton(root: ParentNode = document): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.USER_RECOMMEND_MODAL_CLEAR}"]`);
    }

    public getRecommendButtons(root: ParentNode = document, userId?: number): HTMLElement[] {
        const selector = userId
            ? `[data-role="${Roles.USER_RECOMMEND_BTN}"][data-user-id="${String(userId)}"]`
            : `[data-role="${Roles.USER_RECOMMEND_BTN}"][data-user-id]`;
        return this.queryElements(root, selector, HTMLElement);
    }

    public getClosestRecommendButton(target: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.USER_RECOMMEND_BTN}"]`, HTMLElement);
    }

    public hasRecommendPermission(target: EventTarget | Element | null | undefined): boolean {
        return this.closest(target, '[data-can-recommend="1"]', HTMLElement) instanceof HTMLElement;
    }

    public getButtons(root: ParentNode = document): HTMLButtonElement[] {
        return this.queryElements(root, "button", HTMLButtonElement);
    }

    public getRecommendBadgeRank(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_RECOMMEND_BADGE_RANK}"]`, HTMLElement);
    }
}

export const userRecommendForm = new UserRecommendForm();
